// src/App.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';
import './index.css';
import 'react-phone-number-input/style.css';

// Definindo as cores do Draw Your Goods como tema personalizado
const theme = extendTheme({
  colors: {
    brand: {
      primary: '#A5B4E8',    // Azul lavanda
      secondary: '#B8E8C7',  // Verde menta
      accent1: '#FFECB3',    // Amarelo pastel
      accent2: '#F5C3D8',    // Rosa claro
    },
  },
  fonts: {
    heading: 'Quicksand, sans-serif',
    body: 'Quicksand, sans-serif',
  },
});

// Adicionar a font-face no CSS
const style = document.createElement('style');
style.innerHTML = `
  @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);